export function upreachPaletteProvider($mdThemingProvider) {

    "ngInject";

    $mdThemingProvider.definePalette("upreachPalette", {
        "50": "ffe6ea",
        "100": "ffc1cb",
        "200": "ff98a8",
        "300": "ff6f85",
        "400": "ff506a",
        "500": "ff3150",
        "600": "ff2c49",
        "700": "ff2540",
        "800": "ff1f37",
        "900": "ff1327",
        "A100": "ffffff",
        "A200": "fffafa",
        "A400": "ffc7cb",
        "A700": "ffadb3",
        "contrastDefaultColor": "light",
        "contrastDarkColors": [
            "50",
            "100",
            "200",
            "300",
            "400",
            "A100",
            "A200",
            "A400",
            "A700"
        ],
        "contrastLightColors": [
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    });

    $mdThemingProvider.theme("default")
        .primaryPalette("upreachPalette");
}


// WEBPACK FOOTER //
// ./sources/config/upreachPaletteProvider.config.js